import styleInject from './../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".ErrorAlert-module_alertWrapper__w-8GD {\n  margin-bottom: 15px;\n}";
var styles = {"alertWrapper":"ErrorAlert-module_alertWrapper__w-8GD"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=ErrorAlert.module.scss.js.map
